var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Hidden from '../Hidden';
import AmsterdamLogoStyle, { LogoShortStyle, LogoTallStyle, LogoTitleStyle, } from './AmsterdamLogoStyle';
const AmsterdamLogo = (_a) => {
    var { tall, title = 'Gemeente Amsterdam' } = _a, otherProps = __rest(_a, ["tall", "title"]);
    return (React.createElement(AmsterdamLogoStyle, Object.assign({ tall: tall }, otherProps),
        tall ? (React.createElement(React.Fragment, null,
            React.createElement(Hidden, { minBreakpoint: "laptopM" },
                React.createElement(LogoShortStyle, null)),
            React.createElement(Hidden, { maxBreakpoint: "laptopM" },
                React.createElement(LogoTallStyle, null)))) : (React.createElement(LogoShortStyle, null)),
        React.createElement(LogoTitleStyle, null, title)));
};
export default AmsterdamLogo;
//# sourceMappingURL=AmsterdamLogo.js.map